module.exports = __webpack_public_path__ + "static/img/lgchem.d58ad7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem.png
// module id = C0yR
// module chunks = 0